const VUE_APP_API_GAEA_URL = document.querySelector("body").getAttribute("api_gaea_url");

export default VUE_APP_API_GAEA_URL
